import { render, staticRenderFns } from "./HotSpot.vue?vue&type=template&id=1a597afc&scoped=true&"
import script from "./HotSpot.vue?vue&type=script&setup=true&lang=js&"
export * from "./HotSpot.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a597afc",
  null
  
)

export default component.exports